export default {
    // 获取订单
    getOrderList: 'get /apis/moyin-account/v1/transaction/invoice',

    // 开票历史
    getHistory: 'get /apis/moyin-account/v1/invoice/submit/list',

    //全选获取订单数量和金额
    getNumMoney: 'get /apis/moyin-account/v1/invoice/all/wait',

    //获取发票详情
    getInvoiceDetail: 'get /apis/moyin-account/v1/invoice/submit/invoice/list',

    // 提交开票申请
    submitInvoice:{
        custom: true,
        url: `/apis/moyin-account/v1/invoice/submit`,
        method: 'post',
    },

    // 修改开票申请
    submitInvoiceUpdate:{
        custom: true,
        url: (params)=> `/apis/moyin-account/v1/invoice/submit/${params.submitId}`,
        method: 'put',
    },

    // 重发发票
    reSendInvoice: 'get /apis/moyin-account/v1/invoice/resend',

    // 可在线申请发票的开始时间 
    invoiceStart: 'get /apis/moyin-account/v1/invoice/start',
  }